import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class FloatingHelpService {
    private readonly _open$ = new BehaviorSubject<boolean>(false);
    readonly open$ = this._open$.asObservable();

    public toggle(): void {
        this._open$.next(!this._open$.value);
    }

    public close(): void {
        this._open$.next(false);
    }
}
